import { zonedTimeToUtc } from 'date-fns-tz';

import { convertTime12to24 } from '@service-initiation/shared-utils-date-time';

export const convertTimeSlotToTimestamp = (
  date: string,
  time: string,
  timeZone: string
): number => {
  const time24hr =
    time.indexOf('AM') !== -1 || time.indexOf('PM') !== -1
      ? convertTime12to24(time)
      : time;
  return zonedTimeToUtc(
    `${date.replace(/\//g, '-')} ${time24hr}`,
    timeZone
  ).getTime();
};
